import EditMyCompanyPage from './EditMyCompany';
import { createEditMyCompanyHandle } from './handle';

export default {
  Component: EditMyCompanyPage,
  createHandle: createEditMyCompanyHandle
};
